import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    // {
    //     id: 'applications',
    //     title: 'Applications',
    //     translate: 'APPLICATIONS',
    //     type: 'group',
    //     children: [
    //         {
    //             id: '1',
    //             title: 'Notifiche',
    //             type: 'item',
    //             icon: 'notifications',
    //             url: '/notifications',
    //             checkAdminFalse: true,
    //         },
    //         {
    //             id: '2',
    //             title: 'Segnalazioni create',
    //             type: 'item',
    //             icon: 'chevron_right',
    //             url: '/segnalazione/create',
    //             checkAdminFalse: true,
    //         },
    //         {
    //             id: '3',
    //             title: 'Segnalazioni ricevute',
    //             type: 'item',
    //             icon: 'chevron_left',
    //             url: '/segnalazione/ricevute',
    //             checkAdminFalse: true,
    //         },
    //         {
    //             id: '8',
    //             title: 'Nuova segnalazione',
    //             type: 'item',
    //             icon: 'add',
    //             url: '/segnalazione/nuova',
    //             checkAdminFalse: true,
    //         },
    //         {
    //             id: '4',
    //             title: 'Segnalazioni',
    //             type: 'item',
    //             icon: 'chevron_right',
    //             url: '/notifications',
    //             checkAdmin: true
    //         },
    //         {
    //             id: 'operatori',
    //             title: 'Operatori',
    //             type: 'item',
    //             icon: 'person',
    //             url: '/administration-area/operatori',
    //             checkBankAdmin: true,
    //             checkAdminFalse: true,
    //         },
    //         {
    //             id: '7',
    //             title: 'Gruppi',
    //             type: 'item',
    //             icon: 'group',
    //             url: '/administration-area/gruppi',
    //             checkBankAdmin: true,
    //         },
    //         {
    //             id: '5',
    //             title: 'Report',
    //             type: 'collapsable',
    //             icon: 'event_note',
    //             checkBankAdmin: true,
    //             children: [
    //                 {
    //                     id: '51',
    //                     title: 'Grafici',
    //                     type: 'item',
    //                     icon: 'event_note',
    //                     url: '/report/grafici',
    //                     checkBankAdmin: true,
    //                 },
    //                 {
    //                     id: '52',
    //                     title: 'Export',
    //                     type: 'item',
    //                     icon: 'import_export',
    //                     url: '/report/export',
    //                     checkBankAdmin: true,
    //                 },
    //             ]
    //         },
    //         {
    //             id: '6',
    //             title: 'Admin',
    //             type: 'collapsable',
    //             icon: 'donut_large',
    //             checkAdmin: true,
    //             children: [
    //                 {
    //                     id: '61',
    //                     title: 'Banche / Enti Terzi',
    //                     type: 'item',
    //                     icon: 'credit_card',
    //                     url: '/administration-area/banche',
    //                     checkBankAdmin: true,
    //                 },
    //                 {
    //                     id: '62',
    //                     title: 'Campi Aggiuntivi',
    //                     type: 'item',
    //                     icon: 'notes',
    //                     url: '/administration-area/campi',
    //                     checkBankAdmin: true,
    //                 },
    //                 {
    //                     id: '63',
    //                     title: 'Notifiche',
    //                     type: 'item',
    //                     icon: 'timer',
    //                     url: '/administration-area/temporizzatori',
    //                     checkBankAdmin: true,
    //                 }
    //             ]
    //         },
    //         {
    //             id: 'custom-function',
    //             title: '',
    //             type: 'group',
    //             icon: 'settings',
    //             checkBankAdmin: true,
    //             children: [
    //                 {
    //                     id: 'customize',
    //                     title: 'Mappa Ruoli',
    //                     type: 'item',
    //                     icon: 'supervised_user_circle',
    //                     url: '/mappa-ruoli',
    //                     checkBankAdmin: true,
    //                 }
    //             ]
    //         }
    //     ]
    // }
    {
        id: 'applications',
        title: 'Applications',
        translate: 'APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'backofficeDashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'supervised_user_circle',
                url: '/administration-area/backoffice-dashboard',
                checkAdministrator: true
            },
            {
                id: 'gestioneUtenti',
                title: 'Gestione Utenti',
                type: 'collapsable',
                icon: 'group',
                checkAdministratorOrOperator: true,
                children: [
                    {
                        id: 'lista',
                        title: 'Lista Utenti',
                        type: 'item',
                        icon: 'supervised_user_circle',
                        url: '/administration-area/users',
                        checkAdministratorOrOperator: true,
                    },
                    {
                        id: 'listaCategorieDocenti',
                        title: 'Lista Categorie Formatori',
                        type: 'item',
                        icon: 'shoppingmode',
                        url: '/administration-area/professor-category-list',
                        checkAdministratorOrOperator: true,
                    }
                ]
            }, {
                id: 'gestioneFormazione',
                title: 'Gestione Formazione',
                checkAdministratorOrOperator: true,
                type: 'collapsable',
                icon: 'work',
                children: [
                    {
                        id: 'caetgorylList',
                        title: 'Lista Categorie Softskill',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'list',
                        url: '/administration-area/softskill-categories-list'
                    },
                    {
                        id: 'softskillList',
                        title: 'Lista Softskill',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'list',
                        url: '/administration-area/softskills'
                    },
                    {
                        id: 'salesPackageList',
                        title: 'Lista Pacchetti di Vendita',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'list',
                        url: '/administration-area/salespackage-list'
                    }
                ]
            },
            {
                id: 'documentsSettings',
                title: 'Gestione Documenti',
                checkAdministratorOrOperator: true,
                type: 'collapsable',
                icon: 'description',
                children: [
                    // {
                    //     id: 'FAQ',
                    //     title: 'FAQ',
                    //     checkAdministratorOrOperator: true,
                    //     type: 'item',
                    //     icon: 'help_outline',
                    //     url: '/administration-area/gestione_faq'
                    // },
                    {
                        id: 'PEC',
                        title: 'Privacy&Cookies',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'info',
                        url: '/administration-area/gestione_privacy_e_cookies'
                    },
                    {
                        id: 'TEC',
                        title: 'Terms&Conditions',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'gavel',
                        url: '/administration-area/gestione_termini_e_condizioni'
                    },
                ]
            },
            {
                id: 'SURVEY',
                title: 'Gestione Survey',
                checkAdministratorOrOperator: true,
                type: 'item',
                icon: 'ballot',
                url: '/administration-area/gestione_survey'
            },

            // {
            //     id: 'gestionePianiDiStudio',
            //     title: 'Gestione Piani di Studio',
            //     type: 'collapsable',
            //     icon: 'list_alt',
            //     checkAdministrator: true,
            //     children: [
            //         {
            //             id: 'corsiDiLaurea',
            //             title: 'Corsi di Laurea',
            //             type: 'item',
            //             icon: 'book',
            //             url: '/administration-area/degree-courses',
            //             checkAdministrator: true,
            //         }
            //     ]
            // },
            {
                id: 'gestioneCorsi',
                title: 'Gestione Corsi',
                type: 'collapsable',
                icon: 'collections_bookmark',
                checkAdministrator: true,
                children: [
                    {
                        id: 'statoCorsi',
                        title: 'Stato Corsi',
                        type: 'item',
                        icon: 'book',
                        url: '/administration-area/admin-payments-list',
                        checkAdministrator: true,
                    }
                ]
            },
            // {
            //     id: 'gestioneSegnalazioni',
            //     title: 'Gestione Segnalazioni',
            //     type: 'collapsable',
            //     icon: 'account_balance',
            //     checkAdministratorOrOperator: true,
            //     children: [
            //         {
            //             id: 'lista',
            //             title: 'Lista',
            //             type: 'item',
            //             icon: 'list_alt',
            //             url: '/administration-area/admin-disputes',
            //             checkAdministratorOrOperator: true,
            //         }
            //     ]
            // },
            {
                id: 'emailSettings',
                title: 'Impostazioni E-mail',
                checkAdministratorOrOperator: true,
                type: 'collapsable',
                icon: 'mail',
                children: [
                    {
                        id: 'template',
                        title: 'Gestione Corpo E-Mail',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'alternate_email',
                        url: '/administration-area/email'
                    },
                    {
                        id: 'header',
                        title: 'Gestione Header/Footer',
                        checkAdministratorOrOperator: true,
                        type: 'item',
                        icon: 'view_day',
                        url: '/administration-area/email/header-footer'
                    },
                ]
            },
            {
                id: 'professorDashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/users-area/professor-dashboard',
                checkProfessor: true,
            },
            {
                id: 'studentDashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url: '/users-area/student-dashboard',
                checkStudent: true,
            },
            {
                id: 'gestioneUtentiAziendali',
                title: 'Gestione Utenti Aziendali',
                type: 'collapsable',
                icon: 'group',
                checkCompany: true,
                children: [
                    {
                        id: 'lista',
                        title: 'Lista',
                        type: 'item',
                        icon: 'supervised_user_circle',
                        url: '/users-area/student-company-users',
                        checkCompany: true,
                    }
                ]
            },
            {
                id: 'softskills',
                title: 'Softskills',
                checkStudentOrProfessor: true,
                type: 'collapsable',
                icon: 'work',
                children: [
                    {
                        id: 'softskillsList',
                        title: 'Visualizza tutte',
                        checkStudentOrProfessor: true,
                        type: 'item',
                        icon: 'list',
                        url: '/common-area/softskills-offer'
                    },
                    {
                        id: 'softskillsManagement',
                        title: 'Gestione',
                        checkProfessor: true,
                        type: 'item',
                        icon: 'list',
                        url: '/users-area/professor-softskill'
                    }
                ]
            },
            {
                id: 'trainingOffer',
                title: 'Pacchetti di vendita Attivi',
                type: 'item',
                icon: 'home',
                url: '/common-area/salespackage-offer',
                checkStudentOrProfessor: true,
            },
            {
                id: 'professorCalendar',
                title: 'Calendario',
                type: 'item',
                icon: 'calendar_today',
                url: '/common-area/agenda/calendar',
                // url: '/users-area/professor-calendar',
                checkProfessor: true,
            },
            {
                id: 'leMieDocenze',
                title: 'Le mie docenze',
                type: 'item',
                icon: 'import_contacts',
                url: '/users-area/professor-teachings',
                checkProfessor: true,
            },
            // {
            //     id: 'professorCommunications',
            //     title: 'Comunicazioni',
            //     type: 'item',
            //     icon: 'email',
            //     url: '/users-area/professor-communications',
            //     checkProfessor: true,
            // },
            // {
            //     id: 'professorDisputes',
            //     title: 'Segnalazioni',
            //     type: 'item',
            //     icon: 'account_balance',
            //     url: '/users-area/professor-disputes',
            //     checkProfessor: true,
            // },
            // {
            //     id: 'professorRepository',
            //     title: 'Materiale Didattico',
            //     type: 'item',
            //     icon: 'file_copy',
            //     url: '/users-area/professor-repository',
            //     checkProfessor: true,
            // },
            {
                id: 'studentCalendar',
                title: 'Calendario',
                type: 'item',
                icon: 'calendar_today',
                url: '/common-area/agenda/calendar',
                // url: '/users-area/student-calendar',
                checkStudent: true,
            },
            {
                id: 'iMieiCorsi',
                title: 'I miei corsi',
                type: 'item',
                icon: 'import_contacts',
                url: '/users-area/student-courses',
                checkStudent: true,
            },
            // {
            //     id: 'studentCommunications',
            //     title: 'Comunicazioni',
            //     type: 'item',
            //     icon: 'email',
            //     url: '/users-area/student-communications',
            //     checkStudent: true,
            // },
            // {
            //     id: 'studentDisputes',
            //     title: 'Segnalazioni',
            //     type: 'item',
            //     icon: 'account_balance',
            //     url: '/users-area/student-disputes',
            //     checkStudent: true,
            // },
            // {
            //     id: 'studentRepository',
            //     title: 'Materiale Didattico',
            //     type: 'item',
            //     icon: 'file_copy',
            //     url: '/users-area/student-repository',
            //     checkStudent: true,
            // },
            // {
            //     id: '7',
            //     title: 'Gestione Questionari',
            //     type: 'collapsable',
            //     icon: 'dvr',
            //     checkOperator: true,
            //     children: [
            //         {
            //             id: '8',
            //             title: 'Tutti',
            //             type: 'item',
            //             icon: 'chrome_reader_mode',
            //             url: '/administration-area/questionari',
            //             checkOperator: true,
            //         },
            //         // {
            //         //     id: '18',
            //         //     title: 'Operatori',
            //         //     type: 'item',
            //         //     icon: 'supervised_user_circle',
            //         //     url: '/administration-area/operatori',
            //         //     checkAdmin: true,
            //         // }
            //     ]
            // },
            {
                id: 'admin-report',
                title: 'Report',
                type: 'item',
                icon: 'ballot',
                url: '/administration-area/admin-report',
                checkAdministrator: true
            },
            {
                id: 'configurationsManagement',
                title: 'Gestione Configurazioni',
                type: 'collapsable',
                icon: 'settings_applications',
                checkAdministrator: true,
                children: [
                    {
                        id: 'bestMatchConfig',
                        title: 'Parametri Best Match',
                        type: 'item',
                        icon: 'autorenew',
                        url: '/administration-area/bestMatchConfig'
                    },
                    {
                        id: 'cmsConfig',
                        title: 'Parametri Wordpress',
                        type: 'item',
                        icon: 'list_alt',
                        url: '/administration-area/cmsConfig'
                    },
                    {
                        id: 'backofficeConfig',
                        title: 'Parametri BackOffice',
                        type: 'item',
                        icon: 'domain',
                        url: '/administration-area/backofficeConfig'
                    },
                    {
                        id: 'payPalConfig',
                        title: 'Parametri PayPal',
                        type: 'item',
                        icon: 'payment',
                        url: '/administration-area/payPalConfig'
                    },
                    // {
                    //     id: 'bankTransferConfig',
                    //     title: 'Parametri Bonifico',
                    //     type: 'item',
                    //     icon: 'monetization_on',
                    //     url: '/administration-area/bankTransferConfig'
                    // },
                    {
                        id: 'applicationBehaviorConfig',
                        title: 'Parametri Applicazione',
                        type: 'item',
                        icon: 'settings_applications',
                        url: '/administration-area/applicationBehaviorConfig'
                    }
                ]
            },
            // {
            //     id: '11',
            //     title: 'Gestione Emergenze',
            //     type: 'collapsable',
            //     icon: 'notifications',
            //     children: [
            //         {
            //             id: '12',
            //             title: 'Emergenze in Atto',
            //             type: 'item',
            //             icon: 'playlist_play',
            //             url: '/administration-area/emergencyNotifications'
            //         },
            //         {
            //             id: '13',
            //             title: 'Storico Emergenze',
            //             type: 'item',
            //             icon: 'list',
            //             url: '/administration-area/historyEmergencyNotifications',
            //             checkOperator: true
            //         }
            //     ]
            // },
            // {
            //     id: '14',
            //     title: 'Mappa POI',
            //     type: 'item',
            //     icon: 'group_work',
            //     url: '/administration-area/map',
            //     checkOperator: true,
            // },
            // {
            //     id: '15',
            //     title: 'HeatMap',
            //     type: 'item',
            //     icon: 'apps',
            //     url: '/administration-area/heatmap',
            //     checkOperator: true,
            // },
            // {
            //     id: '16',
            //     title: 'Chat',
            //     type: 'item',
            //     icon: 'chat',
            //     url: '/common-area/chat',
            //     checkStudentOrProfessor: true,
            // },
            // {
            //     id: '17',
            //     title: 'Video Consulto',
            //     type: 'item',
            //     icon: 'voice_chat',
            //     url: '/common-area/videocall',
            //     checkStudentOrProfessor: true,
            // }
        ]
    }
];
